import {performRequest} from 'shared/utils';

import {EUserRoleFunction} from './user-slice-role-functions';

export interface IGetUserFunctionsArgs {
    section: string;
}

export interface IGetUserFunctionsByDocIdArgs {
    tableReportDocId: string;
    templateCode: string;
}

export const getUserFunctions = ({
    section,
}: IGetUserFunctionsArgs) => performRequest<EUserRoleFunction[]>({
    url: `user/functions/${section}`,
});

export const getUserFunctionsByDocId = ({
    tableReportDocId,
}: IGetUserFunctionsByDocIdArgs) => performRequest<EUserRoleFunction[]>({
    url: `user/functions-by-doc/${tableReportDocId}`,
});
